import React, { useState, useContext } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '../SelectValue/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import PassError from '../SelectValue/PassError';
import PasswordField from '../SelectValue/PasswordFieldC';
import { toast } from 'react-toastify';
import postService from '../../Services/post-service';
import getServices from '../../Services/get-service';
import Loading from '../SelectValue/Loading';
import Shimmer from '../SelectValue/Shimmer';
import { UserContext } from '../../Context/UserContext';
import { useNavigate } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: 24,
};

export default function ChangePassword({ open, handleClose }) {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const [charError, setCharError] = useState(false);
  const [upperError, setUpperError] = useState(false);
  const [lowerError, setLowerError] = useState(false);
  const [numError, setNumError] = useState(false);
  const [specialError, setSpecialError] = useState(false);
  const [maxError, setMaxError] = useState(false);
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const handleChange = (event) => {
    const value = event.target.value
    setNewPassword(value)
    if (value.length < 8) {
      setCharError(true);
    } else {
      setCharError(false);
    }
    if (!value.match(/[A-Z]/)) {
      setUpperError(true);
    } else {
      setUpperError(false);
    }
    if (!value.match(/[a-z]/)) {
      setLowerError(true);
    } else {
      setLowerError(false);
    }
    if (!value.match(/\d/)) {
      setNumError(true);
    } else {
      setNumError(false);
    }
    if (!value.match(/[@$!%*?&]/)) {
      setSpecialError(true);
    } else {
      setSpecialError(false);
    }
    if (value.length <= 10) {
      setMaxError(true);
    } else {
      setMaxError(false);
    }
    if (!charError && !upperError && !lowerError && !numError && !specialError && !maxError) {
      setError('');
    } else {
      setError('Invalid Password');
    }
  };
  // const handleForgotPassword = () => {
  //   const userDetails = localStorage.getItem('userdetails')
  //   const parsedDetails = userDetails ? JSON.parse(userDetails) : null
  //   const email = parsedDetails?.email || parsedDetails?.emailAddress || ""

  //   if (!email) {
  //     swal("Email not found. Please log in again.");
  //     return;
  //   }

  //   setLoading(true);
  //   getServices.forgetPassword(email).then(
  //     (response) => {
  //       setLoading(false);
  //       if (response.data.statusCode === 200) {
  //         localStorage.setItem('requestId', response.data.data?.requestId)
  //         localStorage.setItem('resetToken', response.data.data?.token)
  //         localStorage.setItem('email', email)
  //         swal('Otp sent to your mail').then(() => {
  //           navigate('/resetpassword');
  //         });
  //       } else {
  //         swal(response.data.description || "Request failed")
  //       }
  //     },
  //     (error) => {
  //       setLoading(false);
  //       swal(error.response?.data?.description || 'Password reset request failed');
  //     }
  //   )
  // };


  const onSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    const parsedDetails = userDetails || {};
    const email = parsedDetails?.email || parsedDetails?.emailAddress || ""

    if (oldPassword && newPassword) {
      postService.changePassword(email, oldPassword, newPassword).then(
        (response) => {
          setLoading(false)
          if (response.data.statusCode === 200) {
            toast.success(response.data.description || "Password changed successfully");
            setTimeout(() => window.location.reload(), 2000);
          } else {
            toast.error(response.data.description);
          }
        },
        (error) => {
          setLoading(false)
          toast.error(error.response?.data?.description );
        }
      )
    } else {
      setLoading(false)
      toast.error('Please fill in both fields')
    }
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=' rounded-lg p-6 pt-10'>
            {loading ? (
              <div className='mt-5'>
                <Shimmer type="rect" />
                <div className='mt-4'>
                  <Shimmer type="text" />
                </div>
              </div>
            ) : (
              <div className=' h-[70vh] md:mt-8'>
                <div className=' mt-6 flex justify-between mb-3'>
                  <p className=' text-back-color2 text-[18px]  font-[500]'>Change password</p>
                  <div>
                    <CancelIcon onClick={handleClose} className=' text-back-color2 cursor-pointer text-[38px]' fontSize="medium" />
                  </div>
                </div>
                <div >
                  <form onSubmit={onSubmit}>
                    <div className=' w-full mb-3'>
                      <PasswordField
                        label='Current password'
                        onChange={(e) => setOldPassword(e.target.value)}
                        value={oldPassword}
                      />
                    </div>
                    <div className=' w-full mb-3'>
                      <PasswordField
                        label='New password'
                        onChange={handleChange}
                        value={newPassword}
                      />
                    </div>
                    <div className='mt-4 flex gap-3'>
                      <PassError
                        bool={charError}
                        text='8+ Characters'
                      />
                      <PassError
                        bool={upperError}
                        text='Uppercase'
                      />
                      <PassError
                        bool={lowerError}
                        text='Lowercase'
                      />
                    </div>
                    <div className=' mt-4 flex gap-3'>
                      <PassError
                        bool={numError}
                        text='1+ Number'
                      />
                      <PassError
                        bool={specialError}
                        text='1 Special Characters'
                      />
                    </div>
                    <div className=' mt-4 flex gap-3'>
                      <PassError
                        bool={maxError}
                        text='10 Characters maximum'
                      />
                    </div>

                    <div className=' grid grid-cols-1 mb-5 mt-6'>
                      <Button
                        name='Change password'
                      />
                    </div>
                  </form>

                </div>
              </div>
            )}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}